import { Component, Input } from '@angular/core';
import { Question } from '@app/core/models/questionnaire.model';
import { QuestionSubType, RatingScaleSubType } from '@app/core/enums/questionnaire.enums';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rating-scale',
  imports: [CommonModule],
  templateUrl: './rating-scale.html',
  styleUrl: './rating-scale.scss',
})
export class RatingScale {
  @Input() question: Question | null = null; 
  @Input() viewMode: 'mobile' | 'desktop' = 'desktop';
  questionSubType = QuestionSubType;
  ratingScaleSubType = RatingScaleSubType;
 // Enums (adjust if imported from constants)

 selectedRating: number | null = null;

 selectRating(value: number, event: Event) {
  event.stopPropagation();
   this.selectedRating = value;
   console.log('Selected rating:', value);

 }

 /** Safely convert to number */
 toNumber(value: any): number {
   const num = Number(value);
   return isNaN(num) ? 0 : num;
 }

 /** Return [1...count] */
 getScaleArray(count: number): number[] {
   return Array.from({ length: count }, (_, i) => i + 1);
 }
}
